import { Loader2 } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Card, CardContent } from "@/components/ui/card"

/**
 * OKS-734 — Empty / first-pull state (connection present, zero account
 * snapshots yet). Distinct from not-connected: the brand HAS linked TikTok
 * but the first daily sweep hasn't landed. No connect CTA — a reconnect
 * banner is rendered separately by the page when the connection is
 * expired/errored (KD-7).
 */
export function ChannelSyncingCard() {
  const { t } = useTranslation()

  return (
    <Card
      data-testid="channel-analytics-syncing"
      className="mx-auto flex max-w-md flex-col items-center gap-4 p-8 text-center"
    >
      <CardContent className="flex flex-col items-center gap-4 p-0">
        <Loader2
          className="text-muted-foreground h-8 w-8 animate-spin"
          aria-hidden
        />
        <h2 className="text-foreground text-lg font-semibold">
          {t("channel.syncing.title")}
        </h2>
        <p className="text-muted-foreground text-sm">
          {t("channel.syncing.body")}
        </p>
      </CardContent>
    </Card>
  )
}
